import React, {useCallback, useEffect, useId, useRef, useState} from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';

// Una sola decisión por pantalla y cuenta. Cancelar o desmontar nunca ejecuta
// la acción; los permisos/identidad y el registro se revalidan en el emisor.
export default function useConfirmationDialog(scope) {
    const [dialog, setDialog] = useState(null);
    const pending = useRef(null);
    const currentScope = useRef(scope);
    currentScope.current = scope;
    const id = useId();
    useEffect(() => () => {
        const previous = pending.current;
        pending.current = null;
        previous?.resolve(false);
    }, [scope]);
    const settle = useCallback(accepted => {
        const previous = pending.current;
        pending.current = null;
        setDialog(null);
        previous?.resolve(Boolean(accepted && previous.scope === currentScope.current));
    }, []);
    const confirm = useCallback(options => {
        if (pending.current) return Promise.resolve(false);
        const requestScope = currentScope.current;
        return new Promise(resolve => {
            pending.current = {scope:requestScope, resolve};
            setDialog({...options, scope:requestScope});
        }).then(accepted => accepted && requestScope === currentScope.current);
    }, []);
    const confirmationDialog = (
        <Dialog open={Boolean(dialog && dialog.scope === scope)} onClose={() => settle(false)}
            aria-labelledby={`${id}-title`} aria-describedby={`${id}-description`} fullWidth maxWidth="xs">
            <DialogTitle id={`${id}-title`}>{dialog?.title || 'Confirmar acción'}</DialogTitle>
            <DialogContent>
                <DialogContentText id={`${id}-description`} sx={{overflowWrap:'anywhere'}}>{dialog?.message}</DialogContentText>
            </DialogContent>
            <DialogActions sx={{p:2, gap:1, flexWrap:'wrap'}}>
                <Button autoFocus onClick={() => settle(false)} sx={{minHeight:44}}>Cancelar</Button>
                <Button variant="contained" color={dialog?.destructive ? 'error' : 'primary'} onClick={() => settle(true)} sx={{minHeight:44}}>
                    {dialog?.confirmLabel || 'Confirmar'}
                </Button>
            </DialogActions>
        </Dialog>
    );
    return {confirm, confirmationDialog};
}
